export enum LockPolicy {
  None = "none",
  DiscardUnsyncedChanges = "discardUnsyncedChanges",
  ListenForChanges = "listenForChanges",
}
